var __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

define(['jquery', 'underscore', 'underscore.string', 'core', 'component/range-selector/core-storage', 'common/component/date-formatter', 'template/range-selector.htm', 'common/lib/date', 'app-common/lib/picker', 'app-common/lib/picker.date'], function($, _, _s, core, RangeCoreStorage, dateFormatter, rangeTemplate) {
  var IntervalType, Status, addRenderData, areAllMonths, changeInterval, changeIntervalByDates, changeIntervalToAll, changeIntervalYear, createClearDate, currentState, dateSet, dateValues, defaultDate, fillDates, formatToMonthYear, getCurrentIntervalAsDates, getDialogIntervalType, getEarliestDate, getIntervalAsDates, getIntervalAsMonths, getIntervalAsString, getMonthNumberByQuarter, getMonthStatus, getQuarterInterval, getValuesForRendering, intervalChanged, intervalSettings, months, onIntervalChangeCallback, openCalendar, popoverDestroy, prepareTime, quarters, rangeButton, rangeContainer, rangeMetadata, rangeStatusManage, rangeStorage, refreshYearControls, renderCalendars, resetDate, savedState, setEndDateForCurrentInterval, showIntervalType, types, unbindEvents, updateDialog;
  IntervalType = {
    MONTH: 'MONTH',
    QUARTER: 'QUARTER',
    YEAR: 'YEAR',
    CUSTOM: 'CUSTOM',
    ALL: 'ALL'
  };
  Status = {
    INPROGRESS: 'in-progress',
    FINISHED: 'finished',
    CLOSED: 'closed'
  };
  types = [
    {
      key: 'ALL',
      id: 'range-type-all',
      text: 'All',
      selected: false
    }, {
      key: 'YEAR',
      id: 'range-type-year',
      text: 'Annual',
      selected: false
    }, {
      key: 'QUARTER',
      id: 'range-type-quarter',
      text: 'Quarterly',
      selected: false
    }, {
      key: 'MONTH',
      id: 'range-type-month',
      text: 'Monthly',
      selected: false
    }, {
      key: 'CUSTOM',
      id: 'range-type-custom',
      text: 'Custom',
      selected: false
    }
  ];
  months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  quarters = ['Q1', 'Q2', 'Q3', 'Q4'];
  dateValues = {
    MONTH: {},
    QUARTER: {},
    YEAR: {}
  };
  defaultDate = Date.today().moveToFirstDayOfMonth();
  dateSet = false;
  rangeStorage = new RangeCoreStorage;
  intervalSettings = {};
  onIntervalChangeCallback = null;
  rangeButton = null;
  rangeContainer = null;
  rangeMetadata = [];
  rangeStatusManage = false;
  /*
  # Current interval state - this data will be used ONLY internally, for dialog rendering
  #
  # @type {{intervalType: String, selectedDate: Date}}
  */

  currentState = {
    intervalType: null,
    selectedDate: null,
    endDate: null
  };
  /*
  # Last 'saved' interval state - this data will be used by external modules
  #
  # @type {{intervalType: String, selectedDate: Date}}
  */

  savedState = {
    intervalType: null,
    selectedDate: null,
    endDate: null
  };
  getMonthNumberByQuarter = function(value) {
    if (value === quarters[0]) {
      return 0;
    } else if (value === quarters[1]) {
      return 3;
    } else if (value === quarters[2]) {
      return 6;
    } else if (value === quarters[3]) {
      return 9;
    } else {
      return null;
    }
  };
  getQuarterInterval = function(date) {
    var month;
    month = date.getMonth();
    if (month < 3) {
      return {
        from: new Date(date).set({
          day: 1,
          month: 0
        }),
        to: new Date(date).set({
          day: 31,
          month: 2
        })
      };
    } else if (month < 6) {
      return {
        from: new Date(date).set({
          day: 1,
          month: 3
        }),
        to: new Date(date).set({
          day: 30,
          month: 5
        })
      };
    } else if (month < 9) {
      return {
        from: new Date(date).set({
          day: 1,
          month: 6
        }),
        to: new Date(date).set({
          day: 30,
          month: 8
        })
      };
    } else {
      return {
        from: new Date(date).set({
          day: 1,
          month: 9
        }),
        to: new Date(date).set({
          day: 31,
          month: 11
        })
      };
    }
  };
  /*
  # Can take one param - Date object or
  # two params - month & year
  #
  # @param {string|number|date} month
  # @param {string|number} year
  */

  formatToMonthYear = function(month, year) {
    if (_.isDate(month)) {
      year = month.getFullYear();
      month = month.getMonth();
    }
    month = core.formatMonth(month);
    return month + '-' + year;
  };
  getEarliestDate = function() {
    return new Date(rangeStorage.getEarliestDate() || new Date()).moveToFirstDayOfMonth().clearTime();
  };
  setEndDateForCurrentInterval = function() {
    switch (savedState.intervalType) {
      case IntervalType.MONTH:
        return savedState.endDate = new Date(savedState.selectedDate).moveToLastDayOfMonth();
      case IntervalType.QUARTER:
        return savedState.endDate = getQuarterInterval(savedState.selectedDate).to;
      case IntervalType.YEAR:
        return savedState.endDate = new Date(savedState.selectedDate).set({
          day: 31,
          month: 11
        });
      case IntervalType.ALL:
        return savedState.endDate = new Date();
    }
  };
  getIntervalAsDates = function(date, intervalType) {
    if (savedState.endDate == null) {
      savedState.endDate = new Date(date).moveToLastDayOfMonth();
    }
    switch (intervalType) {
      case IntervalType.MONTH:
        return {
          from: new Date(date).moveToFirstDayOfMonth(),
          to: new Date(date).moveToLastDayOfMonth()
        };
      case IntervalType.QUARTER:
        return getQuarterInterval(date);
      case IntervalType.YEAR:
        return {
          from: new Date(date).set({
            day: 1,
            month: 0
          }),
          to: new Date(date).set({
            day: 31,
            month: 11
          })
        };
      case IntervalType.ALL:
        return {
          from: getEarliestDate(),
          to: new Date()
        };
      case IntervalType.CUSTOM:
        return {
          from: date,
          to: savedState.endDate
        };
    }
  };
  getCurrentIntervalAsDates = function() {
    return getIntervalAsDates(savedState.selectedDate, savedState.intervalType);
  };
  getIntervalAsMonths = function() {
    var date, intervalAsDates, intervalType, monthDate, results;
    date = savedState.selectedDate;
    intervalType = savedState.intervalType;
    intervalAsDates = getIntervalAsDates(date, intervalType);
    switch (intervalType) {
      case IntervalType.MONTH:
        return [formatToMonthYear(date)];
      case IntervalType.QUARTER:
      case IntervalType.YEAR:
      case IntervalType.CUSTOM:
        results = [];
        monthDate = new Date(date.getTime());
        while ((intervalAsDates.from <= monthDate && monthDate <= intervalAsDates.to)) {
          results.push(formatToMonthYear(monthDate));
          monthDate = monthDate.add({
            months: 1
          });
        }
        return results;
      default:
        return [];
    }
  };
  getIntervalAsString = function() {
    var dates;
    if (currentState.intervalType === 'ALL') {
      return 'All Dates';
    }
    dates = getCurrentIntervalAsDates();
    return dateFormatter.format(dates.from, {
      shortMonth: true
    }) + ' &mdash; ' + dateFormatter.format(dates.to, {
      shortMonth: true
    });
  };
  resetDate = function(intervalType) {
    var compare, earliestDate;
    if (Date.today().getMonth() === 0 && !dateSet) {
      earliestDate = getEarliestDate();
      compare = earliestDate.compareTo(Date.today().moveToFirstDayOfMonth().addYears(-1));
      if (compare === -1 || compare === 0) {
        defaultDate.addYears(-1);
      }
      dateSet = true;
    }
    return getIntervalAsDates(defaultDate, intervalType).from;
  };
  fillDates = function() {
    var currentYear, earliestYear, month, now, quarter, year, yearObj, _i, _j, _len, _len1, _ref, _results;
    dateValues.YEAR = [];
    dateValues.QUARTER = {};
    dateValues.MONTH = {};
    now = new Date();
    currentYear = now.getFullYear();
    dateValues.YEAR.push({
      value: currentYear,
      enabled: true
    });
    earliestYear = getEarliestDate().getFullYear();
    if (currentYear !== earliestYear) {
      while ((currentYear - earliestYear) !== 0) {
        currentYear--;
        dateValues.YEAR.push({
          value: currentYear,
          enabled: true
        });
      }
    }
    if (dateValues.YEAR.length === 0) {
      return;
    }
    _ref = dateValues.YEAR;
    _results = [];
    for (_i = 0, _len = _ref.length; _i < _len; _i++) {
      yearObj = _ref[_i];
      year = yearObj.value;
      if (dateValues.QUARTER[year] == null) {
        dateValues.QUARTER[year] = [];
      }
      for (_j = 0, _len1 = quarters.length; _j < _len1; _j++) {
        quarter = quarters[_j];
        dateValues.QUARTER[year].push(prepareTime(year, quarter, IntervalType.QUARTER));
      }
      if (dateValues.MONTH[year] == null) {
        dateValues.MONTH[year] = [];
      }
      _results.push((function() {
        var _k, _len2, _results1;
        _results1 = [];
        for (_k = 0, _len2 = months.length; _k < _len2; _k++) {
          month = months[_k];
          _results1.push(dateValues.MONTH[year].push(prepareTime(year, month, IntervalType.MONTH)));
        }
        return _results1;
      })());
    }
    return _results;
  };
  createClearDate = function(year, month) {
    return Date.today().set({
      year: year,
      month: month
    }).moveToFirstDayOfMonth().clearTime();
  };
  prepareTime = function(year, value, type) {
    var checkDate, earliestDate, enabled, intervalEnd, intervalStart, quarterMonthStart;
    enabled = true;
    earliestDate = getEarliestDate();
    quarterMonthStart = getMonthNumberByQuarter(value);
    checkDate = createClearDate(year, (type === IntervalType.MONTH ? _.indexOf(months, value) : quarterMonthStart));
    if (checkDate > Date.today() || checkDate < earliestDate) {
      if (type === IntervalType.QUARTER) {
        intervalStart = createClearDate(year, quarterMonthStart);
        intervalEnd = createClearDate(year, quarterMonthStart + 2);
        enabled = earliestDate > intervalStart && earliestDate < intervalEnd;
      } else {
        enabled = false;
      }
    }
    return {
      value: value,
      enabled: enabled
    };
  };
  intervalChanged = function(updateUI, useCallback) {
    var _ref;
    if (updateUI == null) {
      updateUI = true;
    }
    if (useCallback == null) {
      useCallback = true;
    }
    currentState = _.clone(savedState);
    if (updateUI) {
      updateDialog(savedState);
    }
    rangeStorage.saveInterval({
      intervalFrom: savedState.selectedDate.getTime(),
      intervalTo: ((_ref = savedState.endDate) != null ? _ref.getTime() : void 0) || null,
      intervalType: savedState.intervalType
    });
    if (useCallback) {
      return typeof onIntervalChangeCallback === "function" ? onIntervalChangeCallback() : void 0;
    }
  };
  showIntervalType = function(newIntervalType, updateRangeValue) {
    if (updateRangeValue == null) {
      updateRangeValue = false;
    }
    if (newIntervalType === currentState.intervalType) {
      return;
    }
    currentState.intervalType = newIntervalType;
    return updateDialog(currentState, true, updateRangeValue);
  };
  changeIntervalByDates = function(start, end) {
    var endDate, intervalType, startDate, _ref;
    startDate = start instanceof Date ? start : Date.parse(start);
    endDate = end instanceof Date ? end : Date.parse(end);
    if (endDate < startDate) {
      return false;
    }
    intervalType = new Date(startDate.getTime()).add(1).years().add(-1).days().equals(endDate) && startDate.getDate() === 1 && startDate.getMonth() === 0 ? IntervalType.YEAR : new Date(startDate.getTime()).add(3).months().add(-1).days().equals(endDate) && startDate.getDate() === 1 && ((_ref = startDate.getMonth()) === 0 || _ref === 3 || _ref === 6 || _ref === 9) ? IntervalType.QUARTER : new Date(startDate.getTime()).add(1).months().add(-1).days().equals(endDate) && startDate.getDate() === 1 ? IntervalType.MONTH : IntervalType.CUSTOM;
    savedState.intervalType = intervalType;
    savedState.selectedDate = startDate;
    if (intervalType === IntervalType.CUSTOM) {
      savedState.endDate = endDate;
    }
    intervalChanged(false, false);
    return true;
  };
  changeIntervalYear = function(year, intervalType) {
    currentState.intervalType = intervalType;
    currentState.selectedDate = new Date(currentState.selectedDate).set({
      year: parseInt(year)
    });
    return updateDialog(currentState, true, false);
  };
  changeIntervalToAll = function() {
    savedState.intervalType = IntervalType.ALL;
    savedState.selectedDate = getEarliestDate();
    savedState.endDate = new Date();
    return intervalChanged();
  };
  changeInterval = function(value, intervalType) {
    var currentYear, dateObj;
    if (!value || !intervalType) {
      return;
    }
    dateObj = null;
    currentYear = currentState.selectedDate.getFullYear();
    dateObj = (function() {
      switch (intervalType) {
        case IntervalType.MONTH:
          return {
            month: _.indexOf(months, value),
            year: currentYear
          };
        case IntervalType.QUARTER:
          return {
            month: getMonthNumberByQuarter(value),
            year: currentYear
          };
        case IntervalType.YEAR:
          return {
            month: 0,
            year: parseInt(value)
          };
      }
    })();
    savedState.intervalType = intervalType;
    savedState.selectedDate = new Date(savedState.selectedDate).set(dateObj);
    setEndDateForCurrentInterval();
    return intervalChanged();
  };
  getMonthStatus = function(monthNumber, year) {
    var date, metadata;
    date = formatToMonthYear(monthNumber, year);
    metadata = _.findWhere(rangeMetadata, {
      date: date
    });
    return metadata || {
      date: date,
      status: Status.INPROGRESS
    };
  };
  areAllMonths = function(months, status) {
    return _.all(months, function(month) {
      return month.metadata.status === status;
    });
  };
  addRenderData = function(dateValue, allValues, intervalType, state, year) {
    var closable, closed, monthNumber, quarterEnd, quarterStart, selectedMonth, selectedYear;
    selectedYear = state.selectedDate.getFullYear().toString();
    selectedMonth = state.selectedDate.getMonth();
    switch (intervalType) {
      case IntervalType.MONTH:
        dateValue.openAction = Status.INPROGRESS;
        dateValue.closeAction = Status.FINISHED;
        monthNumber = Date.getMonthNumberFromName(dateValue.value);
        dateValue.metadata = getMonthStatus(monthNumber, year);
        dateValue.showOpen = dateValue.metadata.status !== Status.CLOSED;
        dateValue.showClose = true;
        if (year === selectedYear) {
          return dateValue.selected = state.intervalType === IntervalType.MONTH && monthNumber === selectedMonth;
        }
        break;
      case IntervalType.QUARTER:
        quarterStart = getMonthNumberByQuarter(dateValue.value);
        quarterEnd = quarterStart + 2;
        return dateValue.selected = state.intervalType === IntervalType.QUARTER && selectedMonth <= quarterEnd && selectedMonth >= quarterStart;
      case IntervalType.YEAR:
        dateValue.openAction = Status.FINISHED;
        dateValue.closeAction = Status.CLOSED;
        dateValue.selected = state.intervalType === IntervalType.YEAR && dateValue.value.toString() === selectedYear;
        closable = areAllMonths(allValues.MONTH[dateValue.value], Status.FINISHED);
        closed = areAllMonths(allValues.MONTH[dateValue.value], Status.CLOSED);
        dateValue.showOpen = closable || closed;
        dateValue.showClose = closable || closed;
        return dateValue.metadata = {
          date: dateValue.value,
          status: closed ? Status.CLOSED : Status.INPROGRESS
        };
    }
  };
  getValuesForRendering = function(state) {
    var localDateValues, monthValue, quarterValue, year, yearValue, yearValues, _i, _j, _k, _len, _len1, _len2, _ref, _ref1, _ref2;
    localDateValues = $.extend(true, {}, dateValues);
    _ref = localDateValues.MONTH;
    for (year in _ref) {
      yearValues = _ref[year];
      for (_i = 0, _len = yearValues.length; _i < _len; _i++) {
        monthValue = yearValues[_i];
        addRenderData(monthValue, localDateValues, IntervalType.MONTH, state, year);
      }
    }
    _ref1 = localDateValues.QUARTER;
    for (year in _ref1) {
      yearValues = _ref1[year];
      for (_j = 0, _len1 = yearValues.length; _j < _len1; _j++) {
        quarterValue = yearValues[_j];
        addRenderData(quarterValue, localDateValues, IntervalType.QUARTER, state, year);
      }
    }
    _ref2 = localDateValues.YEAR;
    for (_k = 0, _len2 = _ref2.length; _k < _len2; _k++) {
      yearValue = _ref2[_k];
      addRenderData(yearValue, localDateValues, IntervalType.YEAR, state);
    }
    return localDateValues;
  };
  refreshYearControls = function() {
    if (new Date(currentState.selectedDate).addYears(1).getFullYear() > Date.today().getFullYear()) {
      $('.next-year').addClass('range-disabled');
    } else {
      $('.next-year').removeClass('range-disabled');
    }
    if (new Date(currentState.selectedDate).addYears(-1).getFullYear() < getEarliestDate().getFullYear()) {
      return $('.prev-year').addClass('range-disabled');
    } else {
      return $('.prev-year').removeClass('range-disabled');
    }
  };
  popoverDestroy = function() {
    if (!rangeButton) {
      return;
    }
    rangeButton.popover('destroy');
    rangeButton.removeClass('active');
    $('#range-popover').remove();
    $('body').off('click.range-popover');
    return rangeButton.off('.self');
  };
  openCalendar = function(selector, defaultDate) {
    var $calendar;
    if (defaultDate == null) {
      defaultDate = new Date();
    }
    $calendar = $(selector).pickadate({
      max: new Date(),
      min: getEarliestDate(),
      clear: null,
      today: null,
      format: 'mmmm d, yyyy',
      selectYears: true,
      selectMonths: true,
      onStart: function() {
        return this.set('select', defaultDate, {
          muted: true
        });
      }
    });
    return $calendar.pickadate('picker');
  };
  renderCalendars = function() {
    var changeCallback, dates, enableCalendarSelectboxes, endCal, startCal;
    enableCalendarSelectboxes = function() {
      $('.picker__select--month').prop('disabled', false);
      return $('.picker__select--year').prop('disabled', false);
    };
    if (currentState.intervalType === 'CUSTOM') {
      dates = getCurrentIntervalAsDates();
      startCal = openCalendar('.range-selector__calendar--start', dates.from);
      endCal = openCalendar('.range-selector__calendar--end', dates.to);
      changeCallback = function(e) {
        var $saveButton;
        if (e.select) {
          changeIntervalByDates(startCal.get('select').obj, endCal.get('select').obj);
          $saveButton = $('.range-selector__save-button');
          if (startCal.get('select').obj > endCal.get('select').obj) {
            $saveButton.attr('disabled', 'disabled');
          } else {
            $saveButton.removeAttr('disabled');
          }
        }
        return enableCalendarSelectboxes();
      };
      startCal.on('set', changeCallback.bind(this));
      endCal.on('set', changeCallback.bind(this));
      startCal.on('close', enableCalendarSelectboxes);
      endCal.on('close', enableCalendarSelectboxes);
      enableCalendarSelectboxes();
      return $('.range-selector__calendar').attr('style', '');
    }
  };
  updateDialog = function(state, showDialog, updateRangeValue) {
    var currentRangeValue, currentYear, dates, isYearType, templateVars, type, _i, _len, _ref;
    if (showDialog == null) {
      showDialog = false;
    }
    if (updateRangeValue == null) {
      updateRangeValue = true;
    }
    for (_i = 0, _len = types.length; _i < _len; _i++) {
      type = types[_i];
      type.selected = type.key === state.intervalType;
    }
    currentYear = state.selectedDate.getFullYear();
    currentRangeValue = getIntervalAsString();
    isYearType = state.intervalType === IntervalType.YEAR;
    dates = getValuesForRendering(savedState);
    templateVars = {
      core: core,
      statusManage: rangeStatusManage,
      types: types,
      currentYear: currentYear,
      intervalType: state.intervalType,
      disable: intervalSettings.disable,
      dateValues: isYearType ? dates[state.intervalType] : (_ref = dates[state.intervalType]) != null ? _ref[currentYear] : void 0
    };
    if (updateRangeValue) {
      rangeContainer.html(currentRangeValue);
    }
    popoverDestroy();
    rangeButton.popover({
      html: true,
      trigger: 'manual',
      animation: false,
      placement: 'in bottom',
      appendTo: rangeButton,
      content: _.template(rangeTemplate, templateVars),
      template: '<div id="range-popover" class="range-selector popover"><div class="arrow-wrapper"><div class="ss-gizmo ss-directup"></div></div><div class="popover-inner"><div class="popover-content"><p></p></div></div></div>'
    });
    rangeButton.off('click.self').on('click.self', function(e) {
      var $popover, needToggle;
      $popover = $('#range-popover');
      needToggle = rangeButton[0] === e.target || (rangeButton.has(e.target).length && !$popover.has(e.target).length);
      if (needToggle && $popover.is(':visible')) {
        return $popover.velocity({
          scaleX: [0.8, 1],
          scaleY: [0.8, 1],
          opacity: [0, 1],
          translateZ: 0
        }, {
          duration: 100,
          complete: function() {
            return rangeButton.popover('hide');
          }
        });
      } else if (needToggle) {
        showDialog = false;
        return rangeButton.popover('show');
      }
    });
    rangeButton.on('show.self', function() {
      var $content, $popover, $popoverInner;
      $popoverInner = $('.popover-inner');
      $popover = $('#range-popover');
      if (!showDialog) {
        $popover.velocity({
          scaleX: [1, 0.8],
          scaleY: [1, 0.8],
          opacity: [1, 0],
          translateY: [0, -20],
          translateZ: 0
        }, 100);
      } else {
        $content = $popoverInner.find('.popover-content > p').children().not('#range-type');
        $content.velocity({
          opacity: 0
        }, 0);
        $popover.velocity({
          opacity: 1
        }, 0);
        $content.velocity({
          opacity: 1
        }, 400);
      }
      rangeButton.addClass('active');
      refreshYearControls();
      return renderCalendars();
    });
    rangeButton.on('hide.self', function() {
      return rangeButton.removeClass('active');
    });
    $('body').on('click.range-popover', function(e) {
      var popover;
      popover = $('#range-popover');
      if (popover.is(':visible') && !popover.has(e.target).length && rangeButton[0] !== e.target && !rangeButton.has(e.target).length) {
        popover.addClass('fade');
        return rangeButton.popover('hide');
      }
    });
    if (showDialog) {
      return rangeButton.popover('show');
    }
  };
  getDialogIntervalType = function() {
    var id;
    id = $('.range-types.range-selected').attr('id');
    if (id) {
      return id.replace('range-type-', '').toUpperCase();
    }
  };
  unbindEvents = function() {
    $(document).off('click', '#range-type-month');
    $(document).off('click', '#range-type-quarter');
    $(document).off('click', '#range-type-year');
    $(document).off('click', '.range-item');
    $(document).off('click', '.prev-year');
    return $(document).off('click', '.next-year');
  };
  return {
    init: function(onIntervalChange, settings, storageInstance) {
      var currentInterval, _ref;
      if (settings == null) {
        settings = {
          disable: ['ALL']
        };
      }
      if (storageInstance == null) {
        storageInstance = new RangeCoreStorage;
      }
      intervalSettings = settings;
      rangeStorage = storageInstance;
      fillDates();
      currentInterval = rangeStorage.loadInterval();
      if (!currentInterval || (_ref = currentInterval.intervalType, __indexOf.call(settings.disable, _ref) >= 0)) {
        savedState.intervalType = IntervalType.YEAR;
        savedState.selectedDate = resetDate(savedState.intervalType);
      } else {
        savedState.intervalType = currentInterval.intervalType;
        savedState.selectedDate = new Date(parseInt(currentInterval.intervalFrom));
        savedState.endDate = new Date(parseInt(currentInterval.intervalTo));
      }
      currentState = _.clone(savedState);
      return onIntervalChangeCallback = onIntervalChange;
    },
    initUI: function(button, container, metadata, statusManage) {
      unbindEvents();
      rangeButton = button;
      rangeContainer = container;
      rangeMetadata = metadata;
      rangeStatusManage = statusManage;
      updateDialog(savedState);
      $(document).on('click', '#range-type-month', function() {
        return showIntervalType(IntervalType.MONTH);
      });
      $(document).on('click', '#range-type-quarter', function() {
        return showIntervalType(IntervalType.QUARTER);
      });
      $(document).on('click', '#range-type-year', function() {
        return showIntervalType(IntervalType.YEAR);
      });
      $(document).on('click', '#range-type-custom', function() {
        return showIntervalType(IntervalType.CUSTOM);
      });
      $(document).on('click', '#range-type-all', function() {
        return changeIntervalToAll();
      });
      $(document).on('click', '.range-item', function(e) {
        if ($(this).hasClass('range-disabled') || $(this).hasClass('range-selected')) {
          return;
        }
        if ($(e.target).hasClass('status-change')) {
          return;
        }
        return changeInterval(_s.trim($(this).text()), getDialogIntervalType(), false);
      });
      $(document).on('click', '.prev-year', function() {
        if ($(this).hasClass('range-disabled')) {
          return;
        }
        return changeIntervalYear(parseInt(currentState.selectedDate.getFullYear()) - 1, getDialogIntervalType());
      });
      $(document).on('click', '.next-year', function() {
        if ($(this).hasClass('range-disabled')) {
          return;
        }
        return changeIntervalYear(parseInt(currentState.selectedDate.getFullYear()) + 1, getDialogIntervalType());
      });
      return $(document).on('click', '.range-selector__save-button', function() {
        return intervalChanged();
      });
    },
    makeLeftOffset: function() {
      return rangeButton.on('show', function() {
        var doubledLeft, popover;
        popover = $('#range-popover');
        doubledLeft = parseFloat(popover.css('left')) * 2 - 5;
        popover.css('left', doubledLeft + 'px');
        return popover.children('.arrow-wrapper').css('left', '88%');
      });
    },
    Status: Status,
    changeInterval: changeInterval,
    changeIntervalByDates: changeIntervalByDates,
    getIntervalAsDates: getCurrentIntervalAsDates,
    getIntervalAsString: getIntervalAsString,
    getIntervalAsMonths: getIntervalAsMonths,
    getEarliestDate: getEarliestDate,
    getIntervalType: function() {
      return savedState.intervalType;
    },
    getSelectedIntervalType: function() {
      return currentState.intervalType;
    },
    formatToMonthYear: formatToMonthYear,
    refresh: function(metadata) {
      if (metadata) {
        rangeMetadata = metadata;
      }
      return updateDialog(currentState, true, false);
    },
    hide: function() {
      popoverDestroy();
      return unbindEvents();
    }
  };
});
